import {
  Calendar,
  Users,
  Camera,
  Network,
  KeyRound,
  ArrowUpRight,
} from "lucide-react";

const ITEMS = [
  {
    n: "01",
    icon: Calendar,
    title: "Bi-Weekly Strategy Calls",
    points: [
      "Business strategy",
      "Execution",
      "Sales & marketing",
      "Accountability",
      "Growth",
    ],
  },
  {
    n: "02",
    icon: Users,
    title: "Monthly 1:1 Mentorship",
    points: [
      "Private calls",
      "Personal strategy",
      "Goals & positioning",
      "Next steps",
    ],
  },
  {
    n: "03",
    icon: Camera,
    title: "Monthly Content Days",
    points: [
      "Hosted at FMF Studio",
      "Reels & podcasts",
      "Social content",
      "Personal branding assets",
    ],
  },
  {
    n: "04",
    icon: Network,
    title: "Accountability Community",
    points: [
      "Private network",
      "Networking",
      "Collaboration",
      "Momentum",
    ],
  },
  {
    n: "05",
    icon: KeyRound,
    title: "Direct Access & Resources",
    points: [
      "Frameworks & systems",
      "Practical guidance",
      "Ongoing support",
      "Business templates",
    ],
  },
];

export const Programme = () => {
  return (
    <section
      id="programme"
      data-testid="programme-section"
      className="relative bg-[#080808] py-24 md:py-40 border-t border-zinc-900"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-16 md:mb-24">
          <div className="md:col-span-7">
            <div className="reveal flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-zinc-600" />
              <span className="text-xs tracking-[0.3em] uppercase text-zinc-400 font-bold">
                The Offer
              </span>
            </div>
            <h2
              data-testid="programme-headline"
              className="reveal text-4xl sm:text-5xl lg:text-6xl tracking-tighter font-extrabold text-white leading-[1.02]"
            >
              The Builder <br />
              <span className="italic font-light text-zinc-300">
                Programme.
              </span>
            </h2>
          </div>
          <div className="md:col-span-5 flex md:items-end">
            <p
              data-testid="programme-subheadline"
              className="reveal text-base md:text-lg leading-relaxed text-zinc-400 font-medium"
            >
              A high-accountability environment for ambitious people serious
              about building business, income, content and discipline.
            </p>
          </div>
        </div>

        {/* Bento grid */}
        <div className="grid grid-cols-1 md:grid-cols-6 gap-px bg-zinc-900">
          {ITEMS.map((item, i) => {
            const Icon = item.icon;
            // First row: 3 + 3, second row: 2 + 2 + 2
            const span = i < 2 ? "md:col-span-3" : "md:col-span-2";
            return (
              <div
                key={item.n}
                data-testid={`programme-card-${i + 1}`}
                className={`reveal group relative bg-[#0A0A0A] hover:bg-[#0F0F0F] transition-colors duration-500 p-8 md:p-10 ${span}`}
              >
                <div className="flex items-start justify-between mb-10">
                  <span className="text-xs tracking-[0.3em] uppercase text-zinc-600 font-bold">
                    {item.n} / 05
                  </span>
                  <Icon
                    className="w-5 h-5 text-zinc-500 group-hover:text-white transition-colors duration-300"
                    strokeWidth={1.4}
                  />
                </div>
                <h3 className="text-2xl md:text-3xl tracking-tight font-bold text-white mb-6 leading-tight">
                  {item.title}
                </h3>
                <ul className="space-y-2">
                  {item.points.map((p) => (
                    <li
                      key={p}
                      className="flex items-center gap-3 text-sm text-zinc-400"
                    >
                      <span className="w-1 h-1 bg-zinc-600" />
                      <span>{p}</span>
                    </li>
                  ))}
                </ul>
                <div className="absolute bottom-0 left-0 h-px w-0 bg-white transition-all duration-500 group-hover:w-full" />
              </div>
            );
          })}
        </div>

        <div className="reveal mt-12 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <p className="text-sm text-zinc-500 max-w-xl">
            Applications are limited to maintain quality, focus and
            accountability.
          </p>
          <a
            href="#apply"
            data-testid="programme-apply-cta"
            className="group inline-flex items-center gap-3 text-white border-b border-zinc-700 hover:border-white transition-colors pb-2"
          >
            <span className="text-xs tracking-[0.25em] uppercase font-bold">
              Apply to the Programme
            </span>
            <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
          </a>
        </div>
      </div>
    </section>
  );
};
